console.log("Reasoning Engine Loaded");

const REQUIREMENT_TYPES = {

    home: [
        "home",
        "house",
        "residence"
    ],

    apartment: [
        "apartment",
        "flat"
    ],

    villa: [
        "villa",
        "bungalow"
    ],

    garden: [
        "garden",
        "backyard",
        "yard"
    ],

    farm: [
        "farm",
        "agriculture",
        "farmland"
    ],

    shop: [
        "shop",
        "store"
    ],

    jewellery: [
        "jewellery",
        "jewelry",
        "gold shop"
    ],

    supermarket: [
        "supermarket",
        "grocery",
        "mart"
    ],

    medical: [
        "medical",
        "pharmacy",
        "hospital"
    ],

    office: [
        "office",
        "company"
    ],

    warehouse: [
        "warehouse",
        "godown"
    ],

    factory: [
        "factory",
        "industry"
    ],

    school: [
        "school",
        "college",
        "campus"
    ]

};

const REASONING_RULES = {

    home:{

        recommend:[
            "indoor camera",
            "bulb camera",
            "video doorbell"
        ],

        reason:
        "Home security requires easy installation, remote mobile monitoring and reliable indoor surveillance."

    },

    apartment:{

        recommend:[
            "bulb camera",
            "video doorbell"
        ],

        reason:
        "Apartments usually need compact cameras and smart door monitoring."

    },

    villa:{

        recommend:[
            "outdoor camera",
            "video doorbell",
            "smart sensor"
        ],

        reason:
        "Villas require wider outdoor coverage and smart entrance monitoring."

    },

    shop:{

        recommend:[
            "outdoor camera",
            "dual lens camera",
            "ptz camera"
        ],

        reason:
        "Shops require wider coverage, continuous recording and clear customer monitoring."

    },

    garden: {

    recommend: [
        "outdoor camera",
        "solar camera"
    ],

    reason:
    "Gardens require weather-resistant cameras with wide outdoor coverage."

    },

    jewellery:{

        recommend:[
            "indoor camera",
            "outdoor camera",
            "fingerprint lock",
            "security alarm"
        ],

        reason:
        "Jewellery stores contain high-value items and require continuous surveillance, restricted access and immediate security alerts."

    },

    office:{

        recommend:[
            "fingerprint lock",
            "indoor camera"
        ],

        reason:
        "Offices benefit from controlled access and indoor monitoring."

    },

    warehouse:{

        recommend:[
            "ptz camera",
            "4g camera",
            "outdoor camera"
        ],

        reason:
        "Warehouses require long-range surveillance and monitoring of large open areas."

    }

};

//----------------------------------------
// DETECT CUSTOMER REQUIREMENT
//----------------------------------------

function detectCustomerRequirement(message){

    message = message.toLowerCase();

    let detected = [];

    for(const type in REQUIREMENT_TYPES){

        const keywords = REQUIREMENT_TYPES[type];

        for(const keyword of keywords){

            if(message.includes(keyword)){

                detected.push(type);

                break;

            }

        }

    }

    return detected;

}

//----------------------------------------
// GET PRIMARY REQUIREMENT
//----------------------------------------

function getPrimaryRequirement(message){

    const detected = detectCustomerRequirement(message);

    if(!detected.length){

        return null;

    }

    // Give priority to more specific requirements
    const priority = [

    "jewellery",
    "medical",
    "warehouse",
    "factory",
    "farm",
    "garden",
    "villa",
    "apartment",
    "office",
    "shop",
    "home"

];

    for(const item of priority){

        if(detected.includes(item)){

            return item;

        }

    }

    return detected[0];

}

//----------------------------------------
// GET RECOMMENDATION REASON
//----------------------------------------

function getRecommendationReason(requirement){

    const rule = REASONING_RULES[requirement];

    if(!rule){

        return null;

    }

    return rule;

}